import { StyleSheet } from 'react-native';
import { neutrals } from '../../../../theme/colors';

export const styles = StyleSheet.create({
  container: {
    pointerEvents: 'none',
    zIndex: 10,
    position: 'absolute',
    width: '100%',
    height: '100%',
  },
  cornerBlank: {
    position: 'absolute',
    backgroundColor: neutrals.coldGrays.pearl,
  },
  border: {
    position: 'absolute',
    overflow: 'hidden',
  },
  fade: {
    opacity: 0.5,
  },
  borderOverlay: {
    position: 'absolute',
    overflow: 'hidden',
    backgroundColor: 'rgba(0,0,0,0.3)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    textAlign: 'center',
    color: neutrals.white,
    fontSize: 18,
  },
  borderDashedOverlay: {
    position: 'absolute',
  },
});
